import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/staffGrossSalesSaga";

export const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const rangeOptions = useSelector((state) => state.staffGrossSales.rangeOptions);
  const selectedRangeOption = useSelector((state) => state.staffGrossSales.selectedRangeOption);

  return (
    <div className="select-box-no-width date-range-select-box">
      <p>Date Range</p>
      <MultiSelectDropdown
        options={rangeOptions}
        selectedFilters={selectedRangeOption}
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
      />
    </div>
  );
};
